<template>
  <Layout>
    <div class="header-wrap" slot="header">快麦通密码找回</div>
    <div class="wrap-container">
      <div class="step-wrap">
        <div class="step-item" :class="{ active: currentStep >= 1 }">
          <span class="sequence">1</span>
          <span>确认公司及帐号</span>
        </div>
        <div class="step-item" :class="{ active: currentStep >= 2 }">
          <span class="sequence">2</span>
          <span>安全验证</span>
        </div>
        <div class="step-item" :class="{ active: currentStep >= 3 }">
          <span class="sequence">3</span>
          <span>重置密码</span>
        </div>
      </div>
      <StepFirst v-if="currentStep === 1" @on-success="onStep1Success" />
      <StepSecond v-if="currentStep === 2" :step1Data="step1Data" @on-success="onStep2Success" />
      <StepThird v-if="currentStep === 3" :step1Data="step1Data" @on-success="onStep3Success" />
      <div class="tips-wrap" v-if="currentStep === 3">
        <p>1.密码长度8-20字符，必须同时包含大小写字母、数字，不能含有空格</p>
        <p>2.请不要使用生日、身份证号码、手机号码作为密码</p>
        <p>3.支持特殊符号（仅英文）有：~ ！@ # ^ % & _ - ,./ ? =</p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/LoginLayout';
import PrimaryBtn from '../components/LoginPrimaryBtn';
import { cloneDeep } from 'lodash';
import StepFirst from './components/StepFirst';
import StepSecond from './components/StepSecond';
import StepThird from './components/StepThird';

export default {
  components: {
    Layout,
    PrimaryBtn,
    StepFirst,
    StepSecond,
    StepThird,
  },
  data() {
    return {
      currentStep: 1,
      step1Data: {},
    };
  },
  methods: {
    onStep1Success(data) {
      this.step1Data = cloneDeep(data);
      this.currentStep = 2;
    },
    onStep2Success(data) {
      this.currentStep = 3;
    },
    onStep3Success() {
      this.$alert('重置密码已完成，请妥善保存账号及新密码', '提示', {
        confirmButtonText: '确定',
        type: 'success',
        callback: () => {
          this.$router.push({
            name: 'l_index',
          });
        },
      });
    }
  },
  created() {
    this.$change_color('#396CF3');
    const { step = '' } = this.$route.query;
    if (step) {
      this.currentStep = Number(step);
    }
  }
};
</script>

<style lang="scss" scoped>
.header-wrap {
  margin: 40px 0;
  line-height: 32px;
  color: #26282b;
  font-size: 28px;
  font-weight: 500;
}
.wrap-container {
  min-height: 330px;
  .step-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    margin-bottom: 40px;
    .step-item {
      position: relative;
      font-size: 14px;
      color: #333333;
      span {
        height: 22px;
        line-height: 22px;
        display: inline-block;
        vertical-align: middle;
        &.sequence {
          width: 22px;
          line-height: 20px;
          text-align: center;
          border: 2px solid #dfe2e8;
          border-radius: 12px;
          color: #8c8c8c;
          font-size: 14px;
          margin-right: 4px;
        }
      }
      &.active {
        .sequence {
          border: none;
          background: #396cf3;
          color: #ffffff;
          line-height: 22px;
        }
        &::before {
          background: #396cf3 !important;
        }
      }
      &:not(:first-of-type) {
        padding-left: 26px;
        &::before {
          content: ' ';
          width: 14px;
          height: 2px;
          background: #dfe2e8;
          left: 6px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
  ::v-deep .el-form-item {
    margin-bottom: 24px;
    .el-form-item__label {
      font-size: 14px;
      color: #3d3d3d;
    }
    .el-form-item__content {
      & > span {
        line-height: 26px;
        font-size: 18px;
        color: #333;
        &.el-input__prefix {
          color: #cecece;
        }
      }
    }
    .el-button {
      &:hover {
        color: #396cf3;
        border-color: #396cf3;
      }
    }
  }
  ::v-deep .valicode-row {
    font-size: 12px;
    .link {
      padding: 0;
      color: #396cf3;
    }

    .valicode-input {
      width: 200px;
      margin-right: 12px;
      vertical-align: middle;
    }
    .valicode-pic {
      width: 128px;
      height: 40px;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .valicode-msg-input {
      width: 239px;
      margin-right: 10px;
    }
    .valicode-msg-btn {
      padding: 0 18px;
      height: 40px;
      border-radius: 4px;
    }
  }
  .tips-wrap {
    width: calc(100% + 52px);
    background: #f3f3f3;
    padding: 4px 8px;
    box-sizing: border-box;
    margin-bottom: 24px;
    position: relative;
    left: -26px;
    border-radius: 8px;
    p {
      margin: 0;
      font-size: 12px;
      margin-bottom: 4px;
      line-height: 18px;
      color: #8c8c8c;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
